import { create } from "zustand";

interface SmsNumbersVersionStore {
  version: number;
  invalidate: () => void;
}

export const useSmsNumbersVersion = create<SmsNumbersVersionStore>(set => ({
  version: 0,
  invalidate: () => set(s => ({ version: s.version + 1 })),
}));
